module.exports = __webpack_public_path__ + "static/media/Recruitments01.47e467df.png";